import SortDescendingIcon from './component'

export default SortDescendingIcon
